import { metrics } from '@seek/metrics-js';

import { FORMS, type State } from 'src/context/FormContext';

export const isAppDirty = (state: State) =>
  FORMS.map((formName) => state[formName].dirty).indexOf(true) !== -1;

export const beforeUnload = (state: State) => {
  const warn = isAppDirty(state);

  if (
    warn &&
    (window.APP_CONFIG.SEEK_ENV === 'staging' ||
      window.APP_CONFIG.SEEK_ENV === 'prod')
  ) {
    metrics.count('unsaved-changes-displayed');
    return 'You have unsaved changes.';
  }
};

export const detectUnsavedChanges = (state: State) => {
  if (typeof document !== 'undefined') {
    if (
      document.readyState === 'complete' ||
      document.readyState === 'interactive'
    ) {
      // document is already ready to go
      window.onbeforeunload = () => beforeUnload(state);
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        window.onbeforeunload = () => beforeUnload(state);
      });
    }
  }
};
